import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from "ag-grid-community";
import { ShoppingCartListComponent } from '../../components/shopping-cart-list/shopping-cart-list.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'delete-btn-component',
  template: `
          <span [hidden]="data == null">
            <!-- <span class="my-value">{{getFormatedValue(cellValue , "Coins", "Coins")}}</span> -->
            <button *ngIf="isCxOne" type="button" class="icon-btn fill-valyrianSteel" (click)="isDisabledDeleteButton? null: buttonClicked(data)" [disabled]="isDisabledDeleteButton">
              <svg class="icon-16 fill-hover-cerulean"><use href="../App_Themes/CXone/icons/delete.svg#delete"></use></svg>
            </button>
            <button *ngIf="!isCxOne" type="button" class="icon-btn fill-valyrianSteel" (click)="isDisabledDeleteButton? null: buttonClicked(data)" [disabled]="isDisabledDeleteButton">
              <svg class="icon-16 fill-hover-cerulean"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
            </button>
          </span>
          <!-- <span style="font-weight: bold; color: #353A40;" [hidden]="data != null">
            <span>{{this.shoppingCartListComponent.getLocalizationString("Total", "Total")}}</span>
            <svg class="icon-24 fill-bananaSlug" style="margin: 0 4px;"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
            <span class="">{{this.shoppingCartListComponent.cvNumberLocalize.transform(this.shoppingCartListComponent.getTotal())}}</span>
            <span style="margin-left: 4px;">{{this.shoppingCartListComponent.getLocalizationString("Coins", "Coins")}}</span>
          </span> -->
    `,
})
export class DeleteBtnRenderedComponent implements ICellRendererAngularComp {
  public cellValue!: string;
  public data!: any;
  public isCxOne: boolean = false;
  public isDisabledDeleteButton: boolean = false;

  constructor(public shoppingCartListComponent: ShoppingCartListComponent,
              private cvConfigurationService: CvConfigurationService) {
    this.isCxOne = cvConfigurationService.isCxOne;
   }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.cellValue = this.getValueToDisplay(params);
  }

  // gets called whenever the user gets the cell to refresh
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getFormatedValue(value, key, defaultValue) {
    return this.shoppingCartListComponent.cvNumberLocalize.transform(value) + ' ' + this.shoppingCartListComponent.getLocalizationString(key, defaultValue);
  }

  async buttonClicked(product) {
    this.isDisabledDeleteButton = true;
    await this.shoppingCartListComponent.deleteItemFromCart(product);
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
